module.exports = __webpack_public_path__ + "img/359.3d59cd95.png";